import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { Store } from '@ngrx/store';
import { combineLatest, map } from 'rxjs';
import { selectProjectsLoading } from '../state/projects/projects.selectors';
import { selectFloorsLoading } from '../state/floors/floors.selectors';
import { selectDrawingsLoading } from '../state/drawings/drawings.selectors';
import { selectCaptureSessionsLoading } from '../state/capture-sessions/capture-sessions.selectors';
import { selectCapturesLoading } from '../state/captures/captures.selectors';
import { UserAccessStore } from './user-access/user-access.store';

@Injectable({ providedIn: 'root' })
export class LoadingService {
  private store = inject(Store);
  private userAccessStore = inject(UserAccessStore);

  isLoading$ = combineLatest([
    this.store.select(selectProjectsLoading),
    this.store.select(selectFloorsLoading),
    this.store.select(selectDrawingsLoading),
    this.store.select(selectCaptureSessionsLoading),
    this.store.select(selectCapturesLoading),
    toObservable(this.userAccessStore.loading),
  ]).pipe(
    map(([projects, floors, drawings, sessions, captures, userAccess]) =>
      projects || floors || drawings || sessions || captures || userAccess
    )
  );
}
